import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import isToday from 'date-fns/is_today';

import BetButton from '~shared/components/react/BetButton';
import Time from '~shared/ui/Time/Time';
import {
    DATE_TIME_FORMAT_HM,
    DATE_TIME_FORMAT_DD_MMM,
} from '~shared/utils/constants';
import { getLocalizedDateFormat } from '~shared/utils/date-time';
import { calculateAmericanPrice } from '~shared/components/sport-event/utils';
import {
    useRecommendationNumberOfBets,
    useRecommendationNumberOfBetsThreshold,
} from '~SpectateStore/hooks/clientStateHooks';

import '~shared/styles/bb-icons/_bb-icon-sports.scss';
import './styles.scss';

const RecommendationSelection = ({ recommendation, gtmAttribute }) => {
    const [ t ] = useTranslation();

    const minBetNumber = useRecommendationNumberOfBetsThreshold();
    const showBetNumber = useRecommendationNumberOfBets();

    const {
        counter,
        event_name,
        market_name,
        sport,
        scheduled_start,
        selection_name,
        decimal_price,
        suspended,
    } = recommendation;

    const american_price = calculateAmericanPrice(decimal_price);
    const recommendationSelection = {
        ...recommendation,
        american_price,
        betable: !suspended,
    };

    const headerText = (showBetNumber && (counter > minBetNumber)) ? t('bs_recommends.header_text', { counter }) : t('bs_recommends.title_text_default');

    return (<>
        <li className="fullslip__recommendation">
            <div className="fullslip__recommendation-header">
                {headerText}
            </div>
            <div className="fullslip__recommendation-details">
                <div className="fullslip__recommendation-start-time">
                    <span className={`fullslip__recommendation-sport-icon bb-icon bb-icon--size-30x30 bb-icon--fallback bb-icon--${sport}`} />
                    <Time dateTime={scheduled_start} format={getLocalizedDateFormat(DATE_TIME_FORMAT_HM)} />
                    {!isToday(scheduled_start)
                        ? <Time dateTime={scheduled_start} format={getLocalizedDateFormat(DATE_TIME_FORMAT_DD_MMM)} />
                        : null
                    }
                </div>
                <div className="fullslip__recommendation-selection">
                    <div className="fullslip__recommendation-selection-name">{selection_name}</div>
                    <div>{market_name}</div>
                    <div>{event_name}</div>
                </div>
                <BetButton
                    options={recommendationSelection}
                    gtmAttribute={gtmAttribute}
                />
            </div>
        </li>
    </>);
};

RecommendationSelection.propTypes = {
    recommendation: PropTypes.object,
    gtmAttribute: PropTypes.string,
};

export default RecommendationSelection;
